<template>

    <div>
        <h1>Import Components</h1>
        <v-select
                id="projectSelector"
                :getOptionLabel="option =>option.name"
                @input="setActiveProject"
                :options="existingStructure.projects"
                :value="selectedProject"
                :disabled="stateMessage==='ready'"
        ></v-select>
       <input type="file" @change="onFileChange">
        <br><br>

        <table style="margin-bottom: 50px;">
            <tr :key="ridx +'-'+ row.started" v-for="(row,ridx) in csvToImport">
                <td style="background: azure">
                    <input v-if="row.canImport" type="checkbox" id="checkbox" v-model="row.doImport">
                    <span v-if="row.message">{{row.message}}</span>
                </td>
                <td :key="ridx +'-'+ fidx +'-'+ row.started" v-for="(field,fidx) in row.data">
                    {{field}}
                </td>
            </tr>
        </table>

        <div class="buttonbar">
            <pd-button v-if="stateMessage==='ready'" label="Start Import" :click="invokeImport"></pd-button>
        </div>
    </div>

</template>


<script>
    import {mapGetters, mapState} from 'vuex';
    import Button from "@/components/button";


    export default {
        name: 'importConfigs',
        props: {
            msg: String
        },
        components: {
            "pd-button": Button,
        },
        computed: {
            ...mapState("componentImportStore", [
                "stateMessage","csvToImport","existingStructure","selectedProject"
            ]),
            ...mapGetters('componentImportStore', [
                "stateMessage","csvToImport","existingStructure","selectedProject"
            ])
        },
        methods: {
            onFileChange(e) {
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    return;
                }
                var reader = new FileReader();
                this.$store.commit('componentImportStore/setMessage',"analyze");
                reader.onload = () => {
                    this.$store.commit('componentImportStore/setCsv',reader.result);
                    this.$store.commit('componentImportStore/setMessage',"ready");
                };
                reader.readAsText(files[0]);
            },
            invokeImport(){
                this.$store.commit('componentImportStore/importSelected');
            },
            setActiveProject(project){
                this.$store.commit('componentImportStore/setProject',project);
            }
        },
        created() {
            this.$store.commit('componentImportStore/loadFromDb');
        }
    }
</script>